import React from "react";
import { DrawerComponentProvider } from "./provider";
import DrawerComponentScreen from "./screen";
import DrawerComponentScreenMobile from "./screen-mobile";
import { tabletSize, mobileSize } from "@src/utils/screensize-helper";

const DrawerComponent = () => {
  const isTabletSize = tabletSize();
  const isMobileSize = mobileSize();

  return (
    <DrawerComponentProvider>
      {(isTabletSize || isMobileSize) ? <DrawerComponentScreenMobile /> : <DrawerComponentScreen />}
    </DrawerComponentProvider>
  );
};

export default DrawerComponent;
